import React from 'react'
import { CSVLink } from 'react-csv';
import { Button, Dropdown } from 'antd'
import { DownloadOutlined, DownOutlined } from "@ant-design/icons";
import useTableWeeks from './hooks/useTableWeeks'
import { ToggleSectionButton } from '../../../components/Buttons'
import { TableGeneral } from '../../../components/table/TableGeneral';
import ContainerInfoWeeks from './components/ContainerInfoWeeks';
import { LineChartGeneral } from '../../../components/Graphics/LineChartGeneral';
import ContainerInfoLinerBar from './components/ContainerInfoLinerBar';
import WorkEstimateCard from './components/WorkEstimateCard';

const TableWeeks = () => {
    const {
        stateWeeks,
        buttonCSV,
        sectionMenu,
        handleSectionChange,
        listOfYears,
        updateYear,
        year,
        columns,
        loading,
        onChangeTable,
        downloadCSV
    } = useTableWeeks()


    return (
        <div className="w-full h-full px-3 pt-[32px] flex flex-col gap-[8px]">
            <div className='w-full h-[200px] md:h-[120px] grid grid-cols-1 md:grid-cols-2 items-center md:gap-[12px]'>
                <div className=''>
                    <p className='text-[16px] md:text-[1.5rem] font-bold'>Tabla Semanas</p>
                    <p className='text-[12px] md:text-[0.8rem]'>Comparación entre semanas cotizadas y semana trabajadas</p>
                </div>
                <div className="flex flex-col md:flex-row gap-[12px] md:justify-self-end">
                    <Dropdown
                        menu={{ items: listOfYears, onClick: (data) => updateYear(data.key) }}
                        className="flex items-center justify-center w-full md:w-[120px] shrink-0  text-[12px] "
                    >
                        <Button className="w-full h-full flex items-center justify-center gap-2">
                            {year}
                            <DownOutlined />
                        </Button>
                    </Dropdown>
                    <CSVLink filename={`comparacion-semanas-${year}-${new Date().getTime()}`} data={stateWeeks.csv} className="hidden" ref={buttonCSV} />
                    <Button onClick={() => downloadCSV()} type='default' va icon={<DownloadOutlined />} className='w-full md:w-[160px] h-[42px] text-[12px] flex items-center justify-center'>
                        Descargar
                    </Button>
                    <div className="w-full md:w-[212px] ">
                        <ToggleSectionButton
                            sections={["Tabla", "Gráfica"]}
                            handleSectionChange={handleSectionChange}
                            selectedSection={sectionMenu}
                        />
                    </div>
                </div>
            </div>

            <div className='w-full h-[calc(100%-250px)] overflow-y-auto'>
                <div className={`w-full h-full bg-white ${sectionMenu === 1 ? "hidden" : ""}`}>
                    <TableGeneral
                        column={columns}
                        loading={loading}
                        state={stateWeeks.tableData}
                        scrollX={500}
                        pagination={false}
                        tableProps={{
                            onChange: onChangeTable,
                        }}
                    />
                </div>
                <div className={`w-full h-full ${sectionMenu === 1 ? "" : "hidden"}`}>
                    <div className='w-full h-[100px] flex items-center'>
                        <ContainerInfoWeeks totalsWeeks={stateWeeks.totalsWeeks} />
                    </div>
                    <div className='w-full h-[calc(100%-100px)] bg-white py-[10px] flex flex-col'>
                        <div className='w-full h-[40px] flex items-center justify-end pr-[10px]'>
                            <ContainerInfoLinerBar />
                        </div>
                        <div className='w-full h-[calc(100%-40px)]'>
                            <LineChartGeneral
                                datas={stateWeeks.lineChart}
                                props={{
                                    curve: "natural",
                                    axisLeft: {
                                        legend: '',
                                        legendOffset: 12
                                    },
                                    axisBottom: {
                                        tickRotation: 12,
                                        tickSize: 2,
                                        style: {
                                            text: {
                                                fontSize: 12,
                                                fontWeight: 'bold'
                                            }
                                        }
                                    },
                                    margin: {
                                        bottom: 80,
                                        left: 50,
                                        right: 50,
                                        top: 20
                                    },
                                    sliceTooltip: WorkEstimateCard
                                }}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default TableWeeks